import axios from "axios";

const instance = axios.create({
  // The Cloud function API URL
  baseURL: "https://amazon-backend-chi.vercel.app/api/payment",
});

export default instance;
